module.exports = __webpack_public_path__ + "static/img/zombb.24fe5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/discord/zombb.png
// module id = gvVt
// module chunks = 35